import React from 'react';
import moment from 'moment';
import {
  IBestDataset,
  IRosePlotPreviewData,
  RosePlotChart,
} from '../../../../../types/analytics';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import { TabKey } from '../../../../../utils/common';
import { setDateRangeLimit } from '../../../../../utils/dateRange';
import RosePlot from '../Plot/RosePlot/RosePlot';
import { IEnrichedMetadata } from '../../../../../types/metadata';

interface RosePlotBoxProps {
  activePlotAnalytics: string | null;
  rosePlotPreview?: IRosePlotPreviewData;
  rosePlotPreviewError: string;
  previewDatasetId: string;
  userGroupPermissionDateRange: any;
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
  onDatasetChange: (value: string) => void;
  categoryDataset: IBestDataset[];
  defaultRosePlotDirection: number;
  pointProps: string;
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (value: Partial<IAnalytcisUserInput>) => void;
  errorRosePlot: string;
  loadingRosePlot: boolean;
  handleChangePoint: (item: any, key?: TabKey) => void;
  pointOptions: { label: string; value: string }[];
  point?: MarkerItem;
  updateRosePlotData: RosePlotChart | null;
  setUpdatedRosePlotData: (data: RosePlotChart | null) => void;
  onUpdateRosePlot: (values: any) => void;
  isOffline: boolean;
  enrichedMetadata: IEnrichedMetadata[];
  coordinates: number[];
}

const RosePlotBox: React.FC<RosePlotBoxProps> = ({
  activePlotAnalytics,
  rosePlotPreview,
  rosePlotPreviewError,
  previewDatasetId,
  userGroupPermissionDateRange,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  onDatasetChange,
  categoryDataset,
  defaultRosePlotDirection,
  pointProps,
  pointName,
  userInput,
  updateUserInput,
  errorRosePlot,
  loadingRosePlot,
  handleChangePoint,
  pointOptions,
  updateRosePlotData,
  setUpdatedRosePlotData,
  onUpdateRosePlot,
  isOffline,
  enrichedMetadata,
  coordinates,
}) => {
  if (activePlotAnalytics !== 'Rose Plot') {
    return null;
  }

  const range = setDateRangeLimit(
    moment(rosePlotPreview?.RosePlot?.StartDate),
    moment(rosePlotPreview?.RosePlot?.EndDate),
    true
  );

  return (
    <RosePlot
      previewDatasetId={previewDatasetId}
      previewDatasetTimeRange={userGroupPermissionDateRange}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      onDatasetChange={onDatasetChange}
      datasets={categoryDataset}
      previewError={rosePlotPreviewError}
      defaultValueShortName={rosePlotPreview?.DefaultValueShortName}
      defaultDirectionShortName={rosePlotPreview?.DefaultDirectionShortName}
      variables={
        rosePlotPreview?.RosePlot?.ItemsInfo
          ? rosePlotPreview?.RosePlot?.ItemsInfo
          : rosePlotPreview?.ItemsInfo ?? []
      }
      dateRange={[range[0].toISOString(), range[1].toISOString()]}
      plotData={rosePlotPreview?.RosePlot}
      plotDefaultInterval={defaultRosePlotDirection}
      onUpdateRosePlot={onUpdateRosePlot}
      updatedRosePlotData={updateRosePlotData}
      setUpdatedRosePlotData={setUpdatedRosePlotData}
      pointProps={pointProps}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      errorUpdate={errorRosePlot || rosePlotPreviewError}
      updating={loadingRosePlot}
      onChangeActiveKey={handleChangePoint}
      pointOption={pointOptions}
      enrichedMetadata={enrichedMetadata}
      coordinates={coordinates}
      isOffline={isOffline}
    />
  );
};

export default RosePlotBox;
